<template>
  <div>
    <h1 class="m-label">地図</h1>
    <div style="display: flex">

      <gmap-map
        :center="center"
        :zoom="15"
        style="width: 100%; height: 600px"
      >
        <gmap-marker
          v-for="m in markers"
          :key="m.id"
          :position="m.position"
          :clickable="true"
          :draggable="true"
          @click="center=m.position"
        >
        </gmap-marker>
      </gmap-map>

      <gmap-street-view-panorama class="pano" :position="center" :zoom="1">
      </gmap-street-view-panorama>
    </div>

  </div>
</template>

<script>
export default {
  computed: {
    lat () {
      return Number(this.$store.getters.appointment.lat)
    },

    lng () {
      return Number(this.$store.getters.appointment.lng)
    },

    center () {
      return { lat: this.lat, lng: this.lng }
    },

    markers () {
      return [{ position: { lat: this.lat, lng: this.lng } }]
    }
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
.pano {
  width: 500px;
  height: 300px;
}
</style>



// WEBPACK FOOTER //
// AppointmentMap.vue?3f8a84e3